<template>
  <div style="position:relative;">
    <user-add user-title="案例与新闻" user-add-url="/user/news/add"></user-add>
    <div class="type-list">
      <span v-for="(item,index) in TypeList" :key="index" :class="{active: index == TypeId}"
            @click="TypeChange(index,item.code)">{{item.name}}</span>
    </div>
    <el-table :data="Cdata"  height="81vh">
      <el-table-column label="序号" width="50" prop="id" fixed="left"></el-table-column>
      <el-table-column label="大类"  prop="typeStr" width="80"></el-table-column>
      <el-table-column label="标题" width="240">
        <template slot-scope="scope">
          <span class="description" :title="Cdata[scope.$index].title">{{Cdata[scope.$index].title}}</span>
        </template>
      </el-table-column>
      <el-table-column label="主图" width="120">
        <template slot-scope="scope" >
          <el-image class="item-image" :src="'http://'+Cdata[scope.$index].mainPhotoUrl" alt=""></el-image>
        </template>
      </el-table-column>
      <el-table-column label="主图描述" >
        <template slot-scope="scope" >
          <span class="description" :title="Cdata[scope.$index].mainDescription">{{Cdata[scope.$index].mainDescription}}</span>
        </template>
      </el-table-column>
<!--      <el-table-column label="内容" >-->
<!--        <template slot-scope="scope" >-->
<!--          <span class="description" :title="Cdata[scope.$index].description">{{Cdata[scope.$index].description}}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column label="图片" >-->
<!--        <template slot-scope="scope" >-->
<!--          <el-image class="item-image" :src="'http://'+Cdata[scope.$index].photoUrl" alt=""></el-image>-->
<!--        </template>-->
<!--      </el-table-column>-->

      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleLook(Cdata[scope.$index].id)">查看</el-button>
          <el-button type="text" size="small" @click="handleChange(Cdata[scope.$index].id)">修改</el-button>
          <el-button type="text" size="small" @click="handleDelete(Cdata[scope.$index].id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      class="page"
      :page-size="1"
      style="margin-top:5px;"
      @current-change="handleCurrentChange"
      :total="Cpage"
      layout="prev, pager, next"
    > </el-pagination>
  </div>
</template>

<script>
  import UserAdd from "../Common/UserAdd";
  export default {
    name: "NewsBase",
    components: {UserAdd},
    data(){
      return{
        Cdata:null,//当前表格展示数据
        Cpage:null,//当前获取数据总页数
        TypeId:0,
        TypeList:[
          {'code':1,'name':'典型案例'},
          {'code':2,'name':'新闻资讯'}
          ],
        PostData:{
          'pageNumber':0,
          'pageSize':20,
          'type':1,
          'smallType':null,
        }
      }
    },
    created() {
      this.GetData(this.PostData)
    },
    methods:{
      GetData(PageData){
        this.$axios.post('/api/case/getList',PageData).then(res=>{
          console.log(res)
          this.Cdata=res.data.data.records
          this.Cpage=res.data.data.pages
        })
      },
      handleCurrentChange(index){
        this.PostData.pageNumber=index;
        this.GetData(this.PostData)
      },
      TypeChange(index,code){
        this.TypeId=index;
        this.PostData.type=code
        this.GetData(this.PostData)
      },
      handleLook(id){
        this.$router.push('/user/news/look'+id)
      },
      handleChange(id){
        this.$router.push('/user/news/change'+id)
      },
      Delete(id){
        this.$axios.delete('/api/case/deleteById/'+id).then(res=>{
          this.GetData(this.PostData)
        })
      },
      handleDelete(id){
        this.$confirm('确定删除该条信息', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.Delete(id)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
    }
  }
</script>

<style lang="less" scoped>
.item-base{
  position: relative;
  .type-list{
    position: absolute;
    z-index: 10;
    top: 15px;
    left: 100px;
    span{
      margin: 2px 15px;
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
      line-height: 21px;
      padding: 2px 10px 10px 10px;
    }
    .active{
      border-bottom: 2px solid #188ACB;
      color: #188ACB;
    }
  }
  .description{
    height: 50px;
    white-space: nowrap;
    overflow: hidden;

  }
  .item-image{
    height: 50px;
  }
}
</style>